<template lang="pug">
.cookie
  .content.d-flex.flex-column.flex-md-row.align-items-center.justify-content-center
    p 為提供您最佳個人化且即時的服務，本網站透過使用 Cookies 記錄與存取您的瀏覽使用訊息。 當您瀏覽本網站內容，即表示您同意 Cookies 技術支援。 更多資訊請參閱
      span(@click="toPrivacy", style="cursor: pointer; color: #B9F0ED") 隱私權保護事項
      | 。
    .btn_square.flex-shrink-0(@click="agree") 同意
</template>

<script>
import "@/assets/style/main.scss";
import { setCookieAgree } from "@/utils/auth";

export default {
  components: {},
  data() {
    return {};
  },
  methods: {
    agree() {
      setCookieAgree(true);
      this.$emit("agreeClick");
    },
    toPrivacy() {
      this.$router.push({
        name: "Customize",
        params: {
          page: "legalstatement",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/cookie";
</style>
